class ImageCompare extends HTMLElement {
  connectedCallback() {
    this.frame = this.querySelector('.image-compare__frame');
    if (!this.frame) return;

    this.isTouch = window.matchMedia('(hover: none)').matches;
    this.dragging = false;

    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerDown = this.onPointerDown.bind(this);
    this.onPointerUp = this.onPointerUp.bind(this);

    if (this.isTouch) {
      this.frame.addEventListener('pointerdown', this.onPointerDown);
      this.frame.addEventListener('pointerup', this.onPointerUp);
      this.frame.addEventListener('pointercancel', this.onPointerUp);
      this.frame.addEventListener('pointermove', this.onPointerMoveDrag.bind(this));
    } else {
      this.frame.addEventListener('pointermove', this.onPointerMove);
    }
  }

  setPos(clientX) {
    const rect = this.frame.getBoundingClientRect();
    let pos = ((clientX - rect.left) / rect.width) * 100;
    pos = Math.max(0, Math.min(100, pos));
    this.style.setProperty('--image-compare-pos', pos + '%');
  }

  onPointerMove(e) {
    this.setPos(e.clientX);
  }

  onPointerDown(e) {
    this.dragging = true;
    this.frame.setPointerCapture(e.pointerId);
    this.setPos(e.clientX);
  }

  onPointerMoveDrag(e) {
    if (!this.dragging) return;
    this.setPos(e.clientX);
  }

  onPointerUp(e) {
    this.dragging = false;
    try { this.frame.releasePointerCapture(e.pointerId); } catch (_) {}
  }
}

if (!customElements.get('image-compare')) {
  customElements.define('image-compare', ImageCompare);
}
